import { observer } from 'mobx-react-lite';
import { Form, Formik } from 'formik';
import Popup from '../../../../components/common-components/pop-up/Popup';
import { CalendarDays } from 'lucide-react';
import { useStore } from '../../../../hooks/useStore';
import FormPopupFooter from '../../../../components/form-components/common-components/FormPopupFooter';
import { OvertimeFormSchema } from '../../../../schemas/OvertimeFormSchema';
import {
  getDefaultOvertimeFormValues,
  parseFormDates,
  type OvertimeFormValues,
} from './overtimeFormUtils';
import OvertimeFormFields from './OvertimeFormFields';
import styles from './NewOvertimePopup.module.css';

const NewLeavePopup = () => {
  const { popupStore, overtimeStore, authStore } = useStore();

  const handleClose = () => {
    popupStore.setIsNewLeaveOpen(false);
  };

  const handleSubmit = async (values: OvertimeFormValues) => {
    const { startDate, endDate, totalHours } = parseFormDates(values);

    const response = await overtimeStore.createOvertime({
      startDate,
      endDate,
      description: values.description,
      status: 'Pending',
      overtimeType: 'Leave',
      userId: authStore.user?.id?.toString(),
      totalHours,
    });

    if (!response?.error) {
      popupStore.setIsNewLeaveOpen(false);
    }
  };

  if (!popupStore.isNewLeaveOpen) {
    return null;
  }

  return (
    <Formik
      initialValues={getDefaultOvertimeFormValues()}
      validationSchema={OvertimeFormSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <Popup
          isOpen={popupStore.isNewLeaveOpen}
          onClose={handleClose}
          title="Yeni İzin Kaydı"
          description="Yeni izin kaydı oluşturun"
          variant="success"
          icon={<CalendarDays size={22} strokeWidth={2} />}
          footer={() => <FormPopupFooter onClose={handleClose} />}
        >
          <Form className={styles.form}>
            <OvertimeFormFields descriptionPlaceholder="İzin açıklamasını giriniz..." />
          </Form>
        </Popup>
      )}
    </Formik>
  );
};

export default observer(NewLeavePopup);
